module.exports = __webpack_public_path__ + "static/media/kid22.12058ccf.png";